import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  NgForm,
} from '@angular/forms';
import { DataService } from '../../../core/providers/data/data.service';
import {
  MutationSetOrderCustomFieldsArgs,
} from '../../../common/generated-types';
import { gql } from 'apollo-angular';
import { NGXLogger } from 'ngx-logger';

export const UPDATE_ORDER_CUSTOM_FIELDS = gql`
  mutation UpdateOrderCustomFields($input: UpdateOrderInput!) {
    setOrderCustomFields(input: $input) {
      ... on Order {
        id
        customFields {
          message
        }
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`;

@Component({
    selector: 'vsf-order-message-form',
    templateUrl: './order-message-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderMessageFormComponent implements OnInit {
    @Input() orderMessage: string | null = null;

    message = '';
    expanded = false;
    maxChars = 200;
    isSaving = false;
    collapsedTitle = 'Add a note to your order';

    @ViewChild('messageForm') messageForm: NgForm | undefined;

    constructor(
        private dataService: DataService,
        private changeDetector: ChangeDetectorRef,
        private logger: NGXLogger,
    ) {}

    ngOnInit() {
      this.message = this.orderMessage || '';
    }

    open() {
      if (this.isSaving) return;
      this.message = this.orderMessage || '';
      this.expanded = true;
      this.changeDetector.markForCheck();
    }

    onClose() {
      if (this.isSaving) return;
      this.message = this.orderMessage || '';
      this.messageForm?.resetForm({ orderMessage: this.message });
      this.expanded = false;
      this.changeDetector.markForCheck();
    }

    onSave() {
      if (!this.messageForm || !this.messageForm.form.dirty || this.isSaving) {
        return;
      }
      this.isSaving = true;
      const messageToSave = this.message.trim();

      this.dataService.mutate<MutationSetOrderCustomFieldsArgs>(
        UPDATE_ORDER_CUSTOM_FIELDS, {
          input: {
            customFields: {
              message: messageToSave,
            }
          },
        }
      ).subscribe({
        next: (result: any) => {
          if (result?.setOrderCustomFields.__typename === 'Order') {
            this.orderMessage = messageToSave;
            this.messageForm?.form.markAsPristine();
          }
        },
        error: (error) => {
            this.logger.warn(`Error updating order note:${error}`);
        },
        complete: () => {
            this.isSaving = false;
            this.expanded = false;
            this.changeDetector.markForCheck();
        },
      });
    }

    onRemove() {
      if (this.isSaving) return;
      this.isSaving = true;

      this.dataService.mutate<MutationSetOrderCustomFieldsArgs>(
        UPDATE_ORDER_CUSTOM_FIELDS, {
          input: {
            customFields: {
              message: '',
            }
          },
        }
      ).subscribe({
        next: (result: any) => {
          if (result?.setOrderCustomFields.__typename === 'Order') {
            this.orderMessage = '';
            this.message = '';
            this.messageForm?.resetForm({ orderMessage: '' });
          }
        },
        error: (error) => {
          this.logger.warn(`Error removing order note:${error}`);
        },
        complete: () => {
          this.isSaving = false;
          this.expanded = false;
          this.changeDetector.markForCheck();
        },
      });
    }
}
